import SettingsIcon from '@material-ui/icons/Settings';
import {
    ContainerFieldsList,
    CustomBreadcrumbs,
    CustomSelectInput,
} from 'candy-commons-components';
import React from 'react';
import { useSelector } from 'react-redux';
import {
    ArrayInput,
    BooleanInput,
    Edit,
    ImageField,
    NumberInput,
    SimpleForm,
    SimpleFormIterator,
    SimpleShowLayout,
    TextInput,
    required,
    useTranslate,
} from 'react-admin';
import CustomToolbar from '../../components/CustomToolbar';
import ImageInput from '../../components/ImageInput';
import loadingType from '../../data/loadingType.json';
import enrollmentTypeOptions from '../appliance-wake-up/applianceWakeUp.mock';
import {
    getApplianceTypes,
    getBrands,
    getSeries,
    getSeriesVersion,
} from '../../selectors/cmsConfig';

const RcActivationScreenEdit = ({ permissions = {}, ...props }) => {
    const translation = useTranslate();
    const isEditDisabled = !permissions['rc-activation-screen']?.update;
    const { id } = props;

    const applianceTypes = useSelector(getApplianceTypes);
    const brands = useSelector(getBrands);
    const series = useSelector(getSeries);
    const seriesVersion = useSelector(getSeriesVersion);

    const breadcrumbsData = [
        {
            text: translation('resources.rc-activation-screen.name'),
            url: 'rc-activation-screen',
            icon: <SettingsIcon />,
        },
        {
            text: id,
            url: '',
        },
    ];

    return (
        <>
            <CustomBreadcrumbs data={breadcrumbsData} />
            <Edit {...props}>
                <SimpleForm
                    redirect="list"
                    toolbar={
                        <CustomToolbar
                            permissions={permissions}
                            isEditDisabled={isEditDisabled}
                        />
                    }
                >
                    <ContainerFieldsList>
                        <CustomSelectInput
                            allowEmpty
                            source="applianceType"
                            choices={applianceTypes}
                            disabled={isEditDisabled}
                        />
                        <CustomSelectInput
                            allowEmpty
                            source="brand"
                            choices={brands}
                            disabled={isEditDisabled}
                        />
                        <CustomSelectInput
                            allowEmpty
                            source="series"
                            choices={series}
                            disabled={isEditDisabled}
                        />
                        <CustomSelectInput
                            allowEmpty
                            source="seriesVersion"
                            choices={seriesVersion}
                            disabled={isEditDisabled}
                        />
                        <CustomSelectInput
                            allowEmpty
                            source="loadingType"
                            choices={loadingType}
                            disabled={isEditDisabled}
                        />
                        <CustomSelectInput
                            allowEmpty
                            source="enrollmentType"
                            label="Enrollment Type"
                            choices={enrollmentTypeOptions}
                            translateChoice={false}
                            disabled={isEditDisabled}
                        />
                        <NumberInput
                            source="priority"
                            disabled={isEditDisabled}
                        />
                        <BooleanInput
                            source="isPublished"
                            disabled={isEditDisabled}
                        />
                    </ContainerFieldsList>
                    <ArrayInput
                        source="steps"
                        validate={required()}
                        disabled={isEditDisabled}
                    >
                        <SimpleFormIterator
                            getItemLabel={(index) => `${index + 1}-step`}
                        >
                            <SimpleShowLayout>
                                <ImageField source="imagePath" />
                            </SimpleShowLayout>
                            <TextInput
                                source="title"
                                label="Title"
                                disabled={isEditDisabled}
                            />
                            <ArrayInput
                                source="descriptions"
                                disabled={isEditDisabled}
                            >
                                <SimpleFormIterator>
                                    <TextInput
                                        source="description"
                                        label="Description"
                                        disabled={isEditDisabled}
                                    />
                                </SimpleFormIterator>
                            </ArrayInput>
                            {!isEditDisabled && (
                                <ImageInput
                                    source="imagePath"
                                    label="Image"
                                    accept="image/*"
                                    placeholder={<p>Drop your image here</p>}
                                >
                                    <ImageField source="src" title="title" />
                                </ImageInput>
                            )}
                        </SimpleFormIterator>
                    </ArrayInput>
                </SimpleForm>
            </Edit>
        </>
    );
};

export default RcActivationScreenEdit;
